const axios = require('axios').default;

axios.defaults.headers.common['x-api-key'] =
  'e359ffbb-aaff-422a-b5e3-df1f099dd28e';

async function fetchVoiting() {
  try {
    const response = await axios.get(
      'https://api.thecatapi.com/v1/images/search',
      { params: { limit: 1, size: 'full' } }
    );
    return response.data[0];
  } catch (err) {
    return err;
  }
}

async function fetchImage(image_id) {
  try {
    const response = await axios.get(
      `https://api.thecatapi.com/v1/images/${image_id}`
    );
    return response.data;
  } catch (err) {
    return err;
  }
}

async function voteUp(image_id) {
  let body = {
    image_id,
    value: 1,
    sub_id: 'user-tkach_maxim', // Voting up (you like it) so send 1
  };
  try {
    let response = await axios.post('https://api.thecatapi.com/v1/votes', body);
    return response.data;
  } catch (err) {
    return err;
  } // Send the body to create a Vote in your Account

  //await this.getVotes();
}

async function voteDown(image_id) {
  let body = {
    image_id,
    sub_id: 'user-tkach_maxim',
    value: 0, // Voting down (you don't like) so send 0
  };
  try {
    let response = await axios.post('https://api.thecatapi.com/v1/votes', body);
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function fetchLikes(limit) {
  try {
    let response = await axios.get('https://api.thecatapi.com/v1/votes', {
      params: { sub_id: 'user-tkach_maxim', limit: limit },
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
}

async function addFavorites(image_id) {
  let body = {
    image_id,
    sub_id: 'user-tkach_maxim',
  };
  try {
    let response = await axios.post(
      'https://api.thecatapi.com/v1/favourites/',
      body
    );
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function uploadImage(file) {
  try {
    let response = await axios.post(
      'https://api.thecatapi.com/v1/images/upload',
      file,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (err) {
    console.log(err);
  }
}

async function removeFavorites(favourite_id) {
  try {
    let response = await axios.delete(
      `https://api.thecatapi.com/v1/favourites/${favourite_id}`
    );
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function getVotes() {
  try {
    let response = await axios.get('https://api.thecatapi.com/v1/votes', {
      params: { order: 'DESC', limit: 25 },
    });
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function getFavourites(limit = Infinity) {
  let query_params = {
    limit: limit,
    page: 1,
  };

  try {
    const response = await axios.get(
      'https://api.thecatapi.com/v1/favourites',
      {
        params: query_params,
      }
    );
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function fetchAllBreeds(numberImages, breed, order, types) {
  try {
    const response = await axios.get(
      'https://api.thecatapi.com/v1/images/search',
      {
        params: {
          limit: numberImages,
          breed_id: breed,
          order: order,
          mime_types: types,
        },
      }
    );
    return response.data;
  } catch (err) {
    return err;
  }
}

async function fetchBreedList() {
  try {
    const response = await axios.get('https://api.thecatapi.com/v1/breeds');
    return response.data;
  } catch (err) {
    return console.log(err);
  }
}

async function fetchImagesById(id) {
  try {
    const response = await axios.get('https://api.thecatapi.com/v1/images', {
      params: { image_id: id },
    });
    return response.data;
  } catch (err) {
    return console.log(err);
  }
}

async function fetchBreedByName(name) {
  try {
    const response = await axios.get(
      'https://api.thecatapi.com/v1/breeds/search',
      {
        params: { q: name },
      }
    );
    return response.data;
  } catch (err) {
    return console.log(err);
  }
}

export {
  fetchVoiting,
  fetchAllBreeds,
  fetchBreedList,
  fetchImagesById,
  fetchBreedByName,
  fetchLikes,
  fetchImage,
  uploadImage,
};
export { voteUp, voteDown };
export { addFavorites };
export { getVotes, getFavourites, removeFavorites };
